import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faKey,
} from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import InputField from "../../../components/b2b/InputField";
import BookWithUs from "../../../components/landingPage/BookWithUs";
import DemoService from "../../../components/landingPage/DemoService";
import Footer from "../../../components/landingPage/Footer";
import Header from "../../../components/landingPage/Header";
import OurServices from "../../../components/landingPage/OurServices";
import { getToken, setErr } from "../../../redux/app/auth/auth-slice";
import { accessTokenAction, loginAction } from "../../../api/auth-action";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingIcon from "../../../components/loading/LoadingIcon";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);

  const { errmsg, token } = useSelector((state) => state.auth);

  const [userLoginData, setUserLoginData] = useState({
    email: "",
    password: "",
  });

  const [isPasswordVisible, setisPasswordVisible] = useState(false);
  const [authState, setauthState] = useState();

  useEffect(() => {
    if (token) {
      navigate("/home", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, authState, token]);

  const handleLogin = async (e) => {
    e.preventDefault();
    //
    // localStorage.setItem("firstlogin", true);
    // dispatch({ type: "LOGIN_USER", payload: { userLoginData, navigate } });
    setisLoading(true);
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/user/login`,
      userLoginData,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );

    // if (response?.data?.success) {
    if (response?.data?.success) {
      localStorage.setItem("email", userLoginData.email);

      const tokenResp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/access_Token?email=${userLoginData.email}`,

        {
          withCredentials: true,
        }
      );

      // let tokenResp = {
      //   status: 400,
      // };

      if (tokenResp?.status === 200) {
        dispatch(
          getToken({
            token: tokenResp?.data?.accessToken,
          })
        );
      }
      if (tokenResp?.accessToken) {
        setisLoading(false);
      }

      let auth = localStorage.getItem("firstlogin");
      setauthState(auth);
      toast.success("Login Successfully");
    } else {
      setisLoading(false);
      dispatch(setErr({ errmsg: response?.data?.message }));
    }
  };

  return (
    <div>
      <Header className="static" />

      {/* webview mode */}

      <div className="relative">
        <img
          src={require("../../../assets/images/login_landing.jpg")}
          alt=""
          className="hidden sm:block md:h-1/3 lg:h-[50rem] w-screen xl:h-[42rem] object-cover"
        />

        <div className="bg-black sm:transparent sm:hidden w-screen h-[410px] object-cover"></div>

        <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-full opacity-80 absolute top-0"></div>

        {/* form */}
        <div className="h-full opacity-100 w-full pt-12 sm:pt-3 absolute px-5 transform -translate-y-96 sm:-translate-y-[440px] md:-translate-y-[500px] lg:-translate-y-[650px] xl:-translate-y-[550px]">
          {errmsg ? (
            <p className="flex mx-auto text-lg font-semibold text-center text-red-500 rounded-sm bg-slate-50 w-max px-7 animate__animated animate__bounceIn">
              {errmsg}
            </p>
          ) : (
            <div className="h-[28px]"></div>
          )}
          <div className="flex space-x-0 mb-2.5 px-10"></div>
          <div className="mt-6 text-3xl font-semibold text-center text-white pb-6 sm:pb-14">
            Login to your account
          </div>

          <form
            className="flex-wrap mx-auto space-y-3 w-80 sm:w-96"
            onSubmit={handleLogin}
          >
            <InputField
              isFontawesome={true}
              fontawesomeIcon={faEnvelope}
              placeholder="Email address"
              id="email-address"
              name="email"
              type="email"
              onChange={(e) => {
                dispatch(setErr({ errmsg: "" }));
                setUserLoginData({ ...userLoginData, email: e.target.value });
              }}
            />

            <div className="flex px-4 py-2 font-serif text-black bg-white rounded-md space-x-2 items-center lg:px-2 lg:py-[14px] lg:w-full lg:h-full">
              <FontAwesomeIcon icon={faKey} className="text-xl " />

              {/* PLACEHOLDER */}
              <div className="w-full flex">
                <input
                  className="w-full h-full font-sans  border-none focus:outline-none lg:w-full text-md lg:text-base placeholder:bg-white"
                  placeholder={"Enter your password"}
                  onChange={(e) => {
                    dispatch(setErr({ errmsg: "" }));
                    setUserLoginData({
                      ...userLoginData,
                      password: e.target.value,
                    });
                  }}
                  id="password"
                  name="password"
                  type={isPasswordVisible ? "text" : "password"}
                />
                <div>
                  {!isPasswordVisible ? (
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      icon={faEye}
                      onClick={() => {
                        setisPasswordVisible(!isPasswordVisible);
                      }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      icon={faEyeSlash}
                      onClick={() => {
                        setisPasswordVisible(!isPasswordVisible);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div>
              {!isLoading ? (
                <button
                  onSubmit={handleLogin}
                  className="text-white text-center uppercase bg-secondary hover:bg-gray-700 cursor-pointer w-full font-normal py-1.5 rounded-sm"
                >
                  Login
                </button>
              ) : (
                <div className="bg-secondary  cursor-pointer w-full font-normal py-2.5 rounded-sm mt-5 sm:mt-0">
                  <div className="flex justify-center items-center py-1">
                    <LoadingIcon />
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-between mx-auto">
              <div className="text-sm text-white">
                <div className="text-white text-xs sm:text-sm md:text-base">
                  Don't have an account
                </div>
                <div className="underline cursor-pointer underline-offset-4 text-secondary hover:text-white">
                  <Link to="/SignUp"> Sign Up </Link>
                </div>
              </div>

              <div>
                <Link to="/forgotpassword">
                  <div className="flex justify-center text-xs sm:text-sm md:text-base items-center text-white">
                    Forgot Password?
                  </div>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* <BookWithUs /> */}
      {/* Our Services  */}
      {/* <OurServices /> */}
      {/* car animation */}

      {/* footer */}
      <Footer />
    </div>
  );
};

export default React.memo(Login);
